import React from 'react';

export const NonGreasyIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="38"
    height="34"
    viewBox="0 0 38 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 33C1.13713 30.5193 2.19776 26.584 4.90361 22.6042M20.9518 11.1256C12.9249 13.7257 7.9033 18.1923 4.90361 22.6042M4.90361 22.6042C4.18072 19.7291 4.55663 12.5522 11.8434 6.84577V11.1256L16.6145 4.0711C19.7697 2.7074 23.2819 1.90156 26.5904 1.4601M4.90361 22.6042C16.0072 24.9395 25.7229 17.8269 29.1928 13.9788L25.7229 11.1256H31.7952L37 1.1394C34.6001 0.926058 30.7568 0.904141 26.5904 1.4601M26.5904 1.4601C25.8675 2.14575 24.4217 3.99259 24.4217 5.89472"
      stroke="url(#paint0_linear)"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="9.2428"
        y1="23.6142"
        x2="38.526"
        y2="13.6927"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
    </defs>
  </svg>
);
